import { getTypeRole, dictionaryList } from './request';
import addModal from './addModal.vue';
export default {
  components: {
    addModal
  },
  data() {
    return {
      form: {
        type: undefined,
        role: undefined
      },
      addVisible: false,
      isEdit: false,
      typeList: [],
      roleList: [],
      data: [],
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80,
        align: 'center'
      }, {
        slots: {
          title: '字典名称'
        },
        dataIndex: 'name',
        key: 'name',
        align: 'center'
      }, {
        slots: {
          title: '标识'
        },
        dataIndex: 'mark',
        key: 'mark',
        align: 'center'
      }, {
        slots: {
          title: '字典类型'
        },
        dataIndex: 'type',
        key: 'type',
        align: 'center',
        scopedSlots: {
          customRender: 'type'
        }
      }, {
        slots: {
          title: '使用角色'
        },
        dataIndex: 'role',
        key: 'role',
        align: 'center',
        scopedSlots: {
          customRender: 'role'
        }
      }, {
        slots: {
          title: '操作'
        },
        key: '6',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  created() {
    getTypeRole().then(res => {
      console.log(res);
      this.typeList = res.type;
      this.roleList = res.role;
    });
    this.getDataFun();
  },
  methods: {
    async getDataFun() {
      let params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      Object.assign(params, this.form);
      const {
        items,
        totalNum
      } = await dictionaryList(params);
      this.pagination.total = totalNum;
      this.data = items;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    onSearch() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    openAddModal(value) {
      this.isEdit = value;
      this.addVisible = true;
    }
  }
};